import { SetupPanelItemHelpOption } from "../../QuickSetup/common/components/SetupPanelItem";

export interface DriverAppStep {
  stepNumber: number;
  title: string;
  icon: string;
  label: string;
  body: string;
  breadcrumb: string[];
  /**
   * Help links for the step. Steps 3-6 are Driver App actions and have no walkthrough content
   * yet — the row is hidden in the design too — so these stay empty until DSN supplies scribes.
   */
  helpOptions?: SetupPanelItemHelpOption[];
}

export const driverAppSteps: DriverAppStep[] = [
  {
    stepNumber: 3,
    title: "Add and Verify Your Vehicle",
    icon: "Car",
    label: "Vehicle Details",
    body: "A job can't reach you until you have a verified vehicle on file. Your plan covers one vehicle, so once it's added and verified, you're done with this step for good.",
    breadcrumb: ["In the Driver App", "☰ Menu", "Vehicles"],
  },
  {
    stepNumber: 4,
    title: "Invite Your First Client",
    icon: "Profile2User",
    label: "Client Invitations",
    body: "Before you invite a real client, invite yourself. You'll see exactly what your clients will see.",
    breadcrumb: ["In the Driver App", "☰ Menu", "My Clients"],
  },
  {
    stepNumber: 5,
    title: "Adjust Your Trip Pricing",
    icon: "DollarCircle",
    label: "Pricing Settings",
    body: "Book a test ride to see a real fare, then increase or decrease the default pricing until it feels right.",
    breadcrumb: ["In the Driver App", "☰ Menu", "My Pricing Setting"],
  },
  {
    stepNumber: 6,
    title: "Connect to Your Network",
    icon: "Global",
    label: "Private Network",
    body: "Invite operators you already know and trust. Once connected, surplus bookings can be assigned to your Private Network, and payments are handled automatically.",
    breadcrumb: ["In the Driver App", "☰ Menu", "RM Network"],
  },
];
